import { render, staticRenderFns } from "./createPredictionModal.vue?vue&type=template&id=4c6dba8d&scoped=true&"
import script from "./createPredictionModal.vue?vue&type=script&lang=js&"
export * from "./createPredictionModal.vue?vue&type=script&lang=js&"
import style0 from "./createPredictionModal.vue?vue&type=style&index=0&id=4c6dba8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6dba8d",
  null
  
)

export default component.exports